import { ICoreResponse } from "@/core/interfaces/coreResponse.interface";
import { StatusCodes } from "http-status-codes";
import NewsServices from "@/modules/News/services/news.service";
import { ActionContext, ActionTree } from "vuex";
import { INewsState } from "@/core/interfaces/news.interface";
import { StoreState } from "@/store/type";

const actions: ActionTree<INewsState, StoreState> = {
  async getAllNews(context: ActionContext<INewsState, StoreState>) {
    context.commit("setNewsLoading", true);
    try {
      const newsServices = new NewsServices();

      const response: ICoreResponse = await newsServices.getAllNews();
      if (response.success && response.status === StatusCodes.OK) {
        context.commit("setNews", response.data);
        return response.data;
      } else {
        throw response;
      }
    } catch (err) {
      console.error("Error in fetchNews:", err);
    } finally {
      context.commit("setNewsLoading", false);
    }
  },
};

export default actions;
